export default {
  RemoveFeedbackCriterion: 'Remove Feedback Criterion',
  FeedbackCriterionUpdate: 'Feedback Criterion Update',
  NewFeedbackCriterionAdd: 'NewFeedback Criterion Add',
  StatusChange: 'Status Change',
  FeedbackResponseChange: 'Feedback Response Change',
  ResponseTime: 'Response Time',
  RespondeTimeMin: 'Respond time min',
  RespondeTimeMax: 'Respond time max',
  Accepted: 'Accepted',
  Feedback: 'feed back Criterion',
  Disable: 'Disable',
  CreationTime: 'Creation Time',
  FeedbackResponse: 'Feedback Response',
  Status: 'status',
  UserName: 'User Name',
  FeedbackText: 'Feedback text',
  FeedbackTitle: 'Feedback Title',
  ClientMobilePhone: 'Client Mobile Phone',
  Title: 'Title',
  Enabled: 'Enabled',
  Rejected: 'Rejected',
  WaitingForConfirmation: 'Waiting For Confirmation',
  SortOrder: 'SortOrder',
  Slug: 'Slug',
  FinalRating: 'Final rating',
  approveFeedback: 'Approve feedback',
  rejectFeedback: 'Reject feedback',
  changeToPending: 'Change to pending',
  changeToInProgress: 'Change to in progress',
  areYouSureYouWantToDeleteThisFeedback:
    'Are you sure you want to delete this feedback?',
  areYouSureYouWantToApproveThisFeedback:
    'Are you sure you want to approve this feedback?',
  areYouSureYouWantToRejectThisFeedback:
    'Are you sure you want to reject this feedback?',
  areYouSureYouWantToChangeThisFeedbackStateToPending:
    'Are you sure you want to change this feedback state to pending?',
  areYouSureYouWantToChangeThisFeedbackStateToInProgress:
    'Are you sure you want to change this feedback state to in progress?',
  feedbackResponseSuccessfullyRegistered:
    'Feedback response successfully registered',

  feedbackResponse: 'Feedback response',
  creationTime: 'Creation time',
  responseTime: 'Response time',
  feedback: 'feed back criterion',
  clientMobilePhone: 'Client mobile phone',
  feedbackText: 'Feedback text',
  addFeedback: 'Add feedback',
  editFeedback: 'Edit feedback',
  response: 'response',
}
